export default "__VITE_ASSET__C$hswysT__"